import QS from 'uqs';
const pageParams = QS.parse(location.search);

console.info("pageParams", pageParams);

require('!style-loader!css-loader!video.js/dist/video-js.css');
if(pageParams.show_playlist == '1') {
  require('!style-loader!css-loader!videojs-playlist-ui/dist/videojs-playlist-ui.css');
}
require('!style-loader!css-loader!videojs-ima-v7/dist/videojs.ima.css');
require('!style-loader!css-loader!videojs-errors/dist/videojs-errors.css');

if(!pageParams.simple) {
 require('!style-loader!css-loader!videojs-overlay/dist/videojs-overlay.css');
}

const uniqid = require('uniqid');

import css from '../styles/index.scss';

import axios from 'axios';
import videojs from 'video.js';
import VideoAds from 'videojs-contrib-ads';
import videojsPlaylist from 'fw-videojs-playlist';
import './videojs-playlist-ui';
import IMA from 'videojs-ima-v7';
import 'videojs-errors';
import 'videojs-overlay';
//import 'videojs-youtube';

//videojs.log.level('debug');

console.info("HLS",videojs.Hls.xhr);

//videojs.Hls.GOAL_BUFFER_LENGTH = 30;

import canAutoPlay from 'can-autoplay';

import lazySizes from 'lazysizes';

Number.prototype.mod = function(n) {
  return ((this % n) + n) % n;
};

const gaSiteId = pageParams.ga_id || 'UA-64044530-10';
const custAdParams = 'adid%3D164229280'; 
const dfpNetwork = '31902320';

const getDeviceType = () => {
  if(videojs.browser.IS_IPHONE) {
    return 'phone';
  } else if(videojs.browser.IS_TOUCH_ENABLED) {
    return 'tablet';
  } else {
    return 'desktop';
  }
};

const canUseWebP = () => {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }

    // very old browser like IE 8, canvas not supported
    return false;
};

const getViewportWidth = () => {
  var myWidth = 0, myHeight = 0;
  if( typeof( window.innerWidth ) == 'number' ) {
    //Non-IE
    myWidth = window.innerWidth;
    myHeight = window.innerHeight;
  } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
    //IE 6+ in 'standards compliant mode'
    myWidth = document.documentElement.clientWidth;
    myHeight = document.documentElement.clientHeight;
  } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
    //IE 4 compatible
    myWidth = document.body.clientWidth;
    myHeight = document.body.clientHeight;
  }
  return myWidth;
};

class bPOPInterface {

  constructor() {
    this.deviceType = getDeviceType();
  }

  loadFeed(feedParams) { 
    feedParams.service = 'playlist';
    feedParams.foo = 'bar';
    return new Promise((resolve, reject) => {
      axios.get('https://feeds-cdn.batterypop.net/', {
        params: feedParams,
        responseType:'json',
      })
      .then(function (response) {
        console.log("response", response);
        resolve(response.data);
      })
      .catch(function (error) {
        console.log("error", error);
        reject('FEED LOAD ERROR');
      });
    });
  }

};

class bPOPPlayer {

  constructor(params) {

    //console.info("PARAMS", params);

    //correct bad naming on params
    if(params.mute) {
      params.muted = params.mute;
    }

    if(params.distribution_id) {
      params.distribution = params.distribution_id;
    }

    this.webp = canUseWebP();

    this.deviceType = getDeviceType();

    this.distribution = {};

    this.playlist = [];
    this.vjsPlayer = null;

    this.viewport = {
      "height": window.innerHeight,
      "width": window.innerWidth
    };

    /**console.info("VP", this.viewport);*/

    this.playerState = {
      feedLoaded: false,
      linearAdPlaying: false,
      errorState: false,
      playing: false,
      playlistOpen: false,
      playbackStatus : {}
    };

    this.broadcastConfig = ["playerready", "ended", "useractive", "userinactive"];

    this.trackingConfig = {
      'playbackDivisor': 25,
      'properties': {
        'i': uniqid(),
        'r': document.referrer,
        'd': pageParams.distribution_id,
        'u': this.checkForLocalUUID()
      },
      'events': [
        'timeupdate',
        //'play',
        'pause',
        'ended',
        'readyforpreroll',
        'nopreroll',
        'nopostroll',
        'adstart',
        'adskip',
        'adend',
        'contentended',
        'adserror',
        'adtimeout',
        'volumechange',
        'fullscreenchange'
      ]
    };

    this.playerConfig = {
      fill: true,
      techOrder: ["html5"],
      elementId: uniqid(),
      startEvent: 'click',
      startPosition: 0, //WHICH CLIP TO START WITH
      controlBar: {
        volumePanel: {inline: false},
        fullscreenToggle: false
      },
      imaOptions: {},
      logoBug: {
        'imgUrl': '//cdn.batterypop.net/partner-logos/BatteryPopLogo-sized.png',
        'clickUrl': '//www.batterypop.com'
      },
      autoplay: false,
      muted: false,
      ad_interval: 1, //HOW MANY VIDS UNTIL WE SEE AN AD
    };

    this.playerConfigParams = [
      'autoplay', 'muted', 'debug', 'ad_interval', 'show_playlist'
    ];

    this.feedConfigParams = [
      'distribution', 'ms_uuid', 'mi_uuid', 'ad_tag_url'
    ];

    this.feedParams = {};

    for(let i=0; i < this.playerConfigParams.length; i++) {
      if(params[this.playerConfigParams[i]]) {
        this.playerConfig[this.playerConfigParams[i]] = (params[this.playerConfigParams[i]] === 'false' || params[this.playerConfigParams[i]] === '0') ? false : params[this.playerConfigParams[i]];
      }
    }

    for(let i=0; i < this.feedConfigParams.length; i++) {
      if(params[this.feedConfigParams[i]]) {
        this.feedParams[this.feedConfigParams[i]] = params[this.feedConfigParams[i]];
      }
    }

    console.info(this.playerConfig);

    this.bpopAPI = new bPOPInterface(this.feedParams);

    if(this.feedParams.mi_uuid) {

      //MEDIA UUID PASSED
      console.info("MEDIA UUID PASSED", this.feedParams);
      this.bpopAPI.loadFeed(this.feedParams)
      .then((data) => {
        if(!data.distribution) {
          raiseError('DISTRIBUTION NOT FOUND');
          return;
        }
        if(!data.media_items.length === 0) {
          raiseError('DISTRIBUTION EMPTY');
          return;
        }

        const startItem = data.media_items[0]; //FIRST ONE

        console.info("startItem", startItem);

        if(this.playerConfig.show_playlist) {
          delete this.feedParams.mi_uuid;
          this.feedParams.numperpage = 50;
          //NO MEDIA UUID PASSED
          this.bpopAPI.loadFeed(this.feedParams)
          .then((data) => {
            if(!data.distribution) {
              raiseError('DISTRIBUTION NOT FOUND');
              return;
            }

            if(startItem) {
              let startFound = false;
              for(let i=0; i < data.media_items.length; i++) {
                if(data.media_items[i].uuid === startItem.uuid) {
                  this.playerConfig.startPosition = i;
                  startFound = true;
                  console.log("FOUND startItem in playlist", this.playerConfig.startPosition);
                  break;
                }
              }
              if(startFound === false) { //PUSH IT ONTO THE FRONT
                data.media_items.unshift(startItem);
              }
            }

            if(!data.media_items.length === 0) {
              raiseError('DISTRIBUTION EMPTY');
              return;
            }

            this.distribution = data.distribution;
            this.preparePlaylist(data.media_items)
            .then((playlist) => {
              this.initPlayer();
            })
            .catch((e) => {
              console.error("ERROR " + e);
              this.handleTracking({
                "type": "feed-error",
              });
            });

        })
        .catch((e) => {
          console.error("ERROR " + e);
          raiseError(e);
        });

    } else {
      console.info("SINGLE PLAYER");
      this.playerConfig.singlePlayer = true;
      if(!data.distribution) {
        raiseError('DISTRIBUTION NOT FOUND');
        return;
      }
      this.distribution = data.distribution;
      this.preparePlaylist(data.media_items)
      .then((playlist) => {
        this.initPlayer();
      })
      .catch((e) => {
        console.error("ERROR " + e);
        this.handleTracking({
          "type": "feed-error",
        });
      });
    }

      })
      .catch((e) => {
        console.error("ERROR " + e);
        raiseError(e);
      });

    } else {
      //NO MEDIA UUID PASSED
      this.bpopAPI.loadFeed(this.feedParams)
      .then((data) => {
        if(!data.distribution) {
          raiseError('DISTRIBUTION NOT FOUND');
          return;
        }
        if(!data.media_items.length === 0) {
          raiseError('DISTRIBUTION EMPTY');
          return;
        }

        if(this.startId) {
          for(let i=0; i < data.media_items.length; i++) {
            if(data.media_items[i].uuid === this.startId) {
              this.playerConfig.startPosition = i;
              break;
            }
          }
        }

        this.distribution = data.distribution;
        this.preparePlaylist(data.media_items)
        .then((playlist) => {
          this.initPlayer();
        })
        .catch((e) => {
          console.error("ERROR " + e);
          this.handleTracking({
            "type": "feed-error",
          });
        });
      })
      .catch((e) => {
        console.error("ERROR " + e);
        raiseError(e);
      });
    }

  }

  broadcastEvent (e) {

    switch(e.type) {
      case 'ended':
        const currentItem = this.playlist[this.vjsPlayer.playlist.currentItem()];
        console.info('sending', e.type, currentItem);
        parent.postMessage('ended', "*");
        this.vjsPlayer.off('ended');
        window.location.hash = e.type;
        break;
      case 'playerready':
        console.info("sending", e.type);
        parent.postMessage('playerready', "*");
        this.vjsPlayer.off('playerready');
        window.location.hash = e.type;
        break;
      case 'useractive':
        console.info("sending", e.type);
        parent.postMessage('useractive', "*");
        window.location.hash = e.type;
        break;
      case 'userinactive':
        console.info("sending", e.type);
        parent.postMessage('userinactive', "*");
        window.location.hash = e.type;
        break;
    }

    return;
  
  }

  initializeProgressMarkers() {
    console.info("initializeProgressMarkers", this);
    this.playerState.playbackStatus.greatest_marker = 0;
    this.playerState.playbackStatus._progress_markers = {1 : false};

    for (var j = 0; j < 100; j++) {
      this.playerState.playbackStatus.progress_point = this.trackingConfig.playbackDivisor * Math.floor(j / this.trackingConfig.playbackDivisor);
      this.playerState.playbackStatus._progress_markers[this.playerState.playbackStatus.progress_point] = false;
    }
  }

  preparePlaylist(data) {
    const deviceType = this.deviceType;
    return new Promise((resolve, reject) => {
      resolve(data.map((item) => {

        const itemData = {
          data: {
            uuid: item.uuid,
            series_uuid: item.series_uuid,
            name: item.name,
            series_name: item.series_name,
          },
          series_id: item.series_id,
          series_uuid: item.series_uuid,
          series_name: item.series_name,
          id: item.id,
          uuid: item.uuid,
          name: item.name,
          tag_data: item.tag_data,

          description: item.description,
          duration: item.duration_in_seconds,
          sources: [
          ],
          thumbnail: [
            {
              "alt": item.name,
              "foo": "bar",
              "data-src": this.toSizedImage(item.media.images.phone, '320x180', 'jpg'),
              "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==",
              "class": "b-lazy"
            }
          ],
          poster: this.toSizedImage(item.media.images.desktop, '1024', 'jpg'),
          src: item.media.video[deviceType],
          type: 'video/mp4',
          tag_data: item.tag_data
        };

        if(item.media.video.hls) {
          itemData.sources.push({
              src: item.media.video.hls,
              type: 'application/x-mpegURL',
              overrideNative: true
          });
        } else {
          itemData.sources.push({
              src: item.media.video[deviceType],
              type: 'video/mp4'
          });
        }

        //console.info(itemData);

        this.playlist.push(itemData);

      }));
    });
  }

  initPlayer() {
    const elementId = this.playerConfig.elementId;
    this.createVideoElement();
    const elemInterval = setInterval(() => {
      //console.info("CHECK EL");
      const el = document.getElementById(elementId);
      if(el) {
        //console.info("HAVE EL");
        clearInterval(elemInterval);
        this.fireUpVJS();
      }
    }, 100);
  }

  createVideoElement() {
    //console.info("createVideoElement");
    this.videoElement = document.createElement('video');
    this.videoElement.setAttribute('id', this.playerConfig.elementId);
    this.videoElement.setAttribute('height', '100%');
    this.videoElement.setAttribute('width', '100%');
    this.videoElement.setAttribute('controls', true);
    this.videoElement.setAttribute('oncontextmenu', "return false;");
    //this.videoElement.setAttribute('crossorigin', 'anonymous');
    
    if(this.playerConfig.muted) {
      this.videoElement.setAttribute('muted', 'muted');
    }
    
    this.videoElement.setAttribute('playsinline', 'playsinline');
    this.videoElement.setAttribute('class', 'video-js vjs-bpop vjs-big-play-centered hide');
    
    if(this.playerConfig.autoplay) {
      console.info("AUTOPLAY IN CONFIG");
      canAutoPlay
      .video({timeout: 100, muted: false, inline: true})
      .then(({result, error}) => {
          if(result === false){
              console.info("CAN'T AUTOPLAY WITH SOUND");
              canAutoPlay
              .video({timeout: 100, muted: true, inline: true})
              .then(({result, error}) => {
                  if(result === false){
                    console.info("CAN'T AUTOPLAY MUTED");
                  } else {
                    console.info("CAN AUTOPLAY MUTED");
                    this.playerConfig.muted = true;
                    this.videoElement.setAttribute('muted', 'muted');
                    this.videoElement.setAttribute('autoplay', 'autoplay');
                  }
              });
          } else {
            //console.info("CAN AUTOPLAY WITH SOUND");
            this.videoElement.setAttribute('autoplay', 'autoplay');
          }
      });
    }

    document.body.appendChild(this.videoElement);
  }

  removeOverlay() {
      document.getElementById('overlay').remove();
  }

  handlePlay() {
    //console.info("handlePlay");
    this.playerState.playing = true;
    this.vjsPlayer.one("pause", this.handlePause.bind(this));
    this.closePlaylist();
    //console.info("handledPlay");
  }

  handlePause() {
    //console.info("handlePause");
    this.playerState.playing = false;
    this.vjsPlayer.one("play", this.handlePlay.bind(this));
    //console.info("handledPause");
  }

  setUpEvents() {
    //console.info("setUpEvents");
    this.vjsPlayer.on('playlistchange', function() {
      //console.info("playlistchange");
      this.closePlaylist();
    });
  }

  adsManagerLoadedCallback() {
    console.info("adsManagerLoadedCallback", "this", this);
    const events = [google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
                google.ima.AdEvent.Type.CLICK,
                google.ima.AdEvent.Type.COMPLETE,
                google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
                google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
                google.ima.AdEvent.Type.FIRST_QUARTILE,
                google.ima.AdEvent.Type.LOADED,
                google.ima.AdEvent.Type.MIDPOINT,
                google.ima.AdEvent.Type.PAUSED,
                google.ima.AdEvent.Type.STARTED,
                google.ima.AdEvent.Type.THIRD_QUARTILE];
    for (let index = 0; index < events.length; index++) {
      this.vjsPlayer.ima.addEventListener(
        events[index],
        this.onAdEvent.bind(this)
      );
    }
  }

  onAdEvent(event) {
    if(this.playerConfig.debug) {
      console.info("onAdEvent", event);
    }
    switch(event.type) {

      case google.ima.AdEvent.Type.CLICK:
      case google.ima.AdEvent.Type.LOADED:
      case google.ima.AdEvent.Type.IMPRESSION:
      case google.ima.AdEvent.Type.USER_CLOSED:
      case google.ima.AdEvent.Type.COMPLETE:
      case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
      case google.ima.AdEvent.Type.FIRST_QUARTILE:
      case google.ima.AdEvent.Type.LOADED:
      case google.ima.AdEvent.Type.MIDPOINT:
      case google.ima.AdEvent.Type.PAUSED:
      case google.ima.AdEvent.Type.STARTED:
      case google.ima.AdEvent.Type.THIRD_QUARTILE:
        this.playerState.linearAdPlaying = true;
        this.closePlaylist();
        this.handleTracking(event);
        break;

      case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
      case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
        this.playerState.linearAdPlaying = false;
        this.handleTracking(event);
        break;
    }
  }

  handlePlaylistItem() {

    console.info("handlePlaylistItem");

    const currentItem = this.playlist[this.vjsPlayer.playlist.currentItem()];

    this.vjsPlayer.poster(currentItem.poster);

    this.closePlaylist();
    this.initializeProgressMarkers();
    if(!pageParams.simple) {
      this.vjsPlayer.overlay({
          overlays: [{
            // This overlay will appear when a video is playing and disappear when
            // the player is paused.
            content: currentItem.name,
            align: 'top-left',
            start: 'pause',
            end: 'playing',
            attachToControlBar: true
          }]
        });
    }
  }

  fireUpVJS() {
    //console.info("fireUpVJS");
    this.vjsPlayer = videojs(this.playerConfig.elementId, this.playerConfig);
    
    //console.info("PP", videojs.PlaylistMenuItem);

    const playerObject = this;
    
    this.vjsPlayer.ready(function() {
      

      playerObject.broadcastConfig.map((item) => {
        playerObject.vjsPlayer.on(item, function(e) { playerObject.broadcastEvent(e); });
      });

      playerObject.trackingConfig.events.map((item) => {
        playerObject.vjsPlayer.on(item, function(e) { playerObject.handleTracking(e); });
      });

      console.info("start position", playerObject.playerConfig.startPosition);

      //if(playerConfig.singlePlayer) { 

      //} else {
        playerObject.removeOverlay();
      
        playerObject.vjsPlayer.on('play', (e) => {
          playerObject.closePlaylist();
        });
        playerObject.vjsPlayer.playlist(playerObject.playlist, playerObject.playerConfig.startPosition);
        
        if(!playerObject.playerConfig.singlePlayer) {
          playerObject.vjsPlayer.playlist.repeat(true);  
        }
        
        console.info("playlist", playerObject.vjsPlayer.playlist());

        playerObject.vjsPlayer.playlist.customSrcFunction(function(player, item){
          const currI = player.playlist.currentItem();
          console.info("ad stuff", currI, playerObject.playerConfig.ad_interval, (0 % 0));
          if (
            player.ima && 
            typeof player.ima.setContentWithAdTag === 'function' &&
            currI % playerObject.playerConfig.ad_interval === 0
          ) {
              console.info("SHOW AD");
              player.ima.setContentWithAdTag(item.sources, playerObject.addCustomParams(playerObject.constructAdTag()), true);
              player.ima.requestAds();
          } else {
              player.src(item.sources);
          }
        });
        if(!pageParams.simple) {
          playerObject.vjsPlayer.overlay({
            overlays: [{

              // This overlay will appear when a video is playing and disappear when
              // the player is paused.
              content: playerObject.playlist[playerObject.playerConfig.startPosition].name,
              align: 'top-left',
              start: 'pause',
              end: 'playing',
              attachToControlBar: true
            }]
          });
        }

        //SET UP PLAYLIST DIV
        const plh = document.createElement('div');
        plh.setAttribute('class','hide');
        plh.setAttribute('id','playlist-holder');
        const pld = document.createElement('div');
        pld.setAttribute('class','vjs-playlist hide');
        pld.setAttribute('id','playlist-list-holder');
        
        //plh.appendChild(pld);

        document.getElementById(playerObject.playerConfig.elementId).appendChild(pld);

        playerObject.vjsPlayer.playlist.autoadvance(0);
        playerObject.vjsPlayer.playlistUi({
          playOnSelect: true,
          nextOverlay: true,
          horizontal: true
        });

        const currIdx = playerObject.vjsPlayer.playlist.currentItem() || 0;

        //restart the time played tracker on new clip
        playerObject.vjsPlayer.on("playlistitem", playerObject.handlePlaylistItem.bind(playerObject));

      //}

      if (navigator.userAgent.match(/iPhone/i) ||
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/Android/i)) {
          playerObject.startEvent = 'touchend';
      }

      playerObject.addLogoButton();

      if(!playerObject.playerConfig.singlePlayer) {
        playerObject.addPlaylistButton();
      }
      
      playerObject.setUpListeners();
      playerObject.setUpEvents();
      playerObject.setUpErrorHandling();
      playerObject.removeNativeControlsOnMobile();
      playerObject.initIMA();
      playerObject.turnOnPlaylistContainer();
      playerObject.initializeProgressMarkers();

      /**
      playerObject.vjsPlayer.upnext({
        timeout : 3000,
        headText : 'Up Next',
        cancelText: 'Cancel',
        getTitle : function() { 
          return playerObject.vjsPlayer.player.playlist[playerObject.vjsPlayer.player.playlist.nextIndex()].name;
        },
        next : function () { 
          playerObject.vjsPlayer.playlist.next();
        }
      });
      */

    });
  }

  setUpListeners() {

      window.addEventListener('pause', function(e) {
        this.vjsPlayer.paused(true);
      } , false);

       window.addEventListener('play', function(e) {
        this.vjsPlayer.paused(false);
      } , false);

  }

  handleTracking(e) {

    let ee;
    let ev;

    if(typeof(e) === 'string') {
      e = {
        type: e
      };
    }

    switch (e.type) {

      case 'timeupdate':
        this.playerState.playbackStatus.current = Math.round(this.vjsPlayer.currentTime());
        // We just want to send the percent events once
        const pct = Math.floor(100 * this.playerState.playbackStatus.current / this.vjsPlayer.duration());
        //console.log("timeupdate", this.videosStatus.current, this.player.duration(), pct, this.videosStatus.greatest_marker, this.videosStatus._progress_markers[this.videosStatus.greatest_marker]);
        for (var j in this.playerState.playbackStatus._progress_markers) {
            if (pct >= j) {
              //console.log(pct + " >= " + j);
              if(j > this.playerState.playbackStatus.greatest_marker) {
                //console.log(j + " > " + this.videosStatus.greatest_marker);
                //console.log("set greatest_marker", j);
                this.playerState.playbackStatus.greatest_marker = j;
              }
            }
        }
        if (this.playerState.playbackStatus.greatest_marker) {
            //console.log("have greatest_marker", this.videosStatus.greatest_marker);
            if(!this.playerState.playbackStatus._progress_markers[this.playerState.playbackStatus.greatest_marker]) {
              //console.log("not in progress_markers", this.videosStatus._progress_markers);
              this.playerState.playbackStatus._progress_markers[this.playerState.playbackStatus.greatest_marker] = true;
              ee = 'content-time-' + this.playerState.playbackStatus.greatest_marker;
              ev = this.playerState.playbackStatus.greatest_marker;
            } else {
              //console.log("in progress_markers", this.videosStatus._progress_markers);
            }
        } else {
        //console.log("do not have greatest_marker");
        }
        if(ev >= 25) {
          this.numPlayedVids++;
        }
        
        break;
      
      case 'pause':
        //A VIDEO HAS STARTED PLAYING
        if(this.playerState.playbackStatus._progress_markers[1] === true) {
          ee = 'pause';
          break;
        }

      case '':
        break;

      case 'fullscreenchange':
        ee = this.vjsPlayer.isFullscreen() ? 'enter-fullscreen' : 'exit-fullscreen';
        break;

      case 'contentended':
        break;

      case 'contentStart':
      //showPlaylistToggle();
        ee = 'content-start';
        break;
      
      case 'volumechange':
        if(this.vjsPlayer.volume() > 0) {
          this.vjsPlayer.muted(false);
        }
        ee = 'volume-change';
        break;
      
      case 'adserror':
        ee = 'error-ads';
        //this.player.play();
        break;
      
      case 'adtimeout':
        ee = 'timeout-ads';
        //this.player.play();
        break;
      
      case 'feed-load-error':
        ee = 'error-feed';
        break;

      default:
        if(typeof e === "object" && e.A) {
          ee = "ADS_" + e.type;
          ev = 1;
        } else {
          //ee = e;
          if(this.playerConfig.debug) {
            console.info('handleTracking unknown event', e, e.A);
          }
        }
        break;
    }

    if(!ee) {
      return;
    }

    if(this.playerConfig.debug) {
      console.info('handleTracking event', ee);
    }

    if(ee === 'content-time-1') {
      ee = 'content-play';
    }


    const currentItem = this.playlist[this.vjsPlayer.playlist.currentItem()];

    //console.info('handleTracking item', currentItem);

    if(!ee || !ev) {
      if(this.playerConfig.debug) {
      console.info('handleTracking empty EE or EV', ee, ev);
      }
    }

    const dimData = {
        hitType: 'event',
        eventCategory: this.trackingConfig.properties.d,
        eventAction: ee,
        eventLabel: currentItem.series_name,
        dimension1: this.trackingConfig.properties.d,
        dimension2: currentItem.series_uuid,
        dimension3: currentItem.series_name,
        dimension4: currentItem.uuid,
        dimension5: currentItem.name,
        dimension6: this.trackingConfig.properties.r,
        dimension7: this.trackingConfig.properties.i,
        dimension8: this.playerConfig.autoplay,
        dimension9: this.playerConfig.muted,
        dimension10: this.trackingConfig.properties.u
    };

    if(this.playerConfig.debug) {
      console.info('handleTracking dims', e, dimData);
    }
    ga('send', dimData);

  }

  checkForLocalUUID() {
    try {
      //OLD LOCAL STORAGE WAY
      let uuidU =localStorage.getItem('batterypop-user');
      console.info('uuidU', uuidU);
      if(uuidU === null) {
        console.info('uuidU is empty');
        uuidU = uniqid();
        localStorage.setItem('batterypop-user', uuidU);
      }
      return uuidU;
    } catch(e) {
      console.error('localStorage does not work', e);
      return null;
    }
  }

  setUpErrorHandling() {
    return;
    /**
    MEDIA_ERR_ABORTED (numeric value 1)
    MEDIA_ERR_NETWORK (numeric value 2)
    MEDIA_ERR_DECODE (numeric value 3)
    MEDIA_ERR_SRC_NOT_SUPPORTED (numeric value 4)
    MEDIA_ERR_ENCRYPTED (numeric value 5)
    */
    this.vjsPlayer.errors({
      errors: {
        1: {
          headline: 'Oops!',
          message: 'Looks like that video stopped playing.  We\'re working on it!'
        },
        2: {
          headline: 'Oops!',
          message: 'Looks like that video won\'t load right now.  We\'re working on it!'
        },
        3: {
          headline: 'Oops!',
          message: 'Looks like there\'s a problem with that video.  We\'ll get it fixed as soon as possible'
        },
        4: {
          headline: 'Oops!',
          message: 'This video is not compatible with your browser.'
        },
        5: {
          headline: 'Oops!',
          message: 'We are not able to play this video on your device.  You may not have access or your browser may not be able to play it.'
        }
      }
    });
  }

  addPlaylistButton() {
    const ButtonComponent = videojs.getComponent('Button');
    const playerClass = this;
    const MyButtonComponent = videojs.extend(ButtonComponent, { 
      constructor: function() { 
        ButtonComponent.call(this, this.vjsPlayer); 
      }, 
      handleClick: function(){
        //console.info("handlePlaylistButtonClick", this);
        if(playerClass.playerState.playlistOpen) {
          this.removeClass('selected');
          this.blur();
          playerClass.closePlaylist();
          
        } else {
          this.addClass('selected');
          playerClass.openPlaylist();
        }
        
      } 
    });
    const playlistButton = this.vjsPlayer.controlBar.addChild(new MyButtonComponent(), {}); 
    playlistButton.addClass("vjs-playlist-button");
  }

  addLogoButton() {

    const ButtonComponent = videojs.getComponent('Button');
    const playerClass = this;
    const MyButtonComponent = videojs.extend(ButtonComponent, { 
      constructor: function() { 
        ButtonComponent.call(this, this.vjsPlayer); 
      }, 
      handleClick: function(){ 
        window.open(playerClass.playerConfig.logoBug.clickUrl, '_blank');
      } 
    });
    const logoButton = this.vjsPlayer.controlBar.addChild(new MyButtonComponent(), {}, 0); 
    logoButton.addClass("vjs-customlogo-button");
  }

  removeNativeControlsOnMobile() {
    const contentPlayer =  document.getElementById(this.playerConfig.elementId + '_html5_api');
    if ((navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/Android/i)) &&
        contentPlayer.hasAttribute('controls')) {
      contentPlayer.removeAttribute('controls');
    }
  }

  constructAdTag() {
    let adTagUrl = this.distribution.ad_tag;
    let adStatus = this.distribution.ad_status;

    if(this.feedParams.ad_tag_url) {
      adTagUrl = this.feedParams.ad_tag_url;
      adStatus = 'enabled';
    }

    if(adStatus!= 'enabled'){
      adTagUrl = '';
    } else {
      if( adTagUrl.indexOf('http://') > -1 || adTagUrl.indexOf('https://') > -1) {
      }
      else
      {   
        adTagUrl = 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/'+dfpNetwork+'/'+adTagUrl+'&impl=s&gdfp_req=1&env=vp&output=xml_vast3&unviewed_position_start=1&url=[referrer_url]&description_url=[description_url]&correlator=[timestamp]';
      }
    }

    console.info("ad", adTagUrl);

    //SAMPLE TAG FOR TESTING
    //adTagUrl = 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator=';

    if (navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPhone/i)) {
        adTagUrl = adTagUrl.replace('%3Dskippablelinear','%3Dlinear');
    }

    return adTagUrl;

  }

  addCustomParams (adTagUrl) {

    console.info("addCustomParams", adTagUrl);

    if(adTagUrl.indexOf('&cust_params') !== -1) {
      console.info("HAS CUST PARAMS");
      return adTagUrl;
    }

    let str = '';
    const currentItem = this.playlist[this.vjsPlayer.playlist.currentItem()];

    if(adTagUrl === '') {
      console.info("EMPTY AD TAG");
      return '';
    }

    str += 'category%3D' + currentItem.tag_data.category.map(function(item){return (item && item.length > 0) ? item.replace(/\s/g, '') : null;}).join("%2C");
    str += '%26genre%3D' + currentItem.tag_data.genre.map(function(item){return (item && item.length > 0) ? item.replace(/\s/g, '') : null;}).join("%2C");
    str += '%26demo%3D' + currentItem.tag_data.demographic.map(function(item){return (item && item.length > 0) ? item.replace(/\s/g, '') : null;}).join("%2C");
    str += '%26series%3D' + currentItem.data.series_uuid;
    str += '%26clip%3D' + currentItem.data.uuid;

    adTagUrl += '&cust_params=' + str;

    console.log("FINAL TAG URL", adTagUrl);

    return adTagUrl;
  }

  initIMA() {
    // Initialize the ad container when the video player is clicked, but only the
    // first time it's clicked.

    this.playerConfig.imaOptions = {
      id: 'content_video',
      adTagUrl: this.addCustomParams(this.constructAdTag()),
      disableCustomPlaybackForIOS10Plus: true,
      adsManagerLoadedCallback: this.adsManagerLoadedCallback.bind(this)
    };

    //this.playerConfig.imaOptions = {};

    console.info("IMA OPTS", this.playerConfig.imaOptions);

    this.vjsPlayer.ima(this.playerConfig.imaOptions);
    if(!this.playerConfig.autoplay || this.playerConfig.autoplay === 'false') {
      console.info("NOT AUTOPLAY", document.getElementById(this.playerConfig.elementId));
      if (navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/Android/i)) {
        this.startEvent = 'touchend';
      }
      document.getElementById(this.playerConfig.elementId).addEventListener(this.startEvent, this.initAdDisplayContainer.bind(this));
    } else {
      console.info("IS AUTOPLAY");
      //this.vjsPlayer.play();
    }
  }

  initAdDisplayContainer() {
    this.vjsPlayer.ima.initializeAdDisplayContainer();
    document.getElementById(this.playerConfig.elementId).removeEventListener(this.startEvent, initAdDisplayContainer);
  }

  closePlaylist() {
    //console.info("closePlaylist", this.playerState.playing);
    if(this.playerState.playing) {
      this.vjsPlayer.play();
    }

    const butts = document.getElementsByClassName('.vjs-playlist-button');
    if (butts.length > 0) {
      butts[0].classList.remove('selected');
    }

    const playlistHolder = document.getElementById('playlist-list-holder');
    if(playlistHolder.classList.contains('hide')) {
      return;
    } else {
      playlistHolder.classList.remove('show');
      playlistHolder.classList.add('hide');
      this.playerState.playlistOpen = false;
      this.closePlaylistToggle();
    }
  }

  closePlaylistToggle() {
    return;
    const toggleHolder = document.getElementById('playlist-toggle');
    if(toggleHolder.classList.contains('close')) {
      return;
    } else {
      toggleHolder.classList.remove('open');
      toggleHolder.classList.add('close');
    }
  }

  openPlaylist() {
    //console.info('openPlaylist', this);

    if(this.vjsPlayer) {
      if(!this.vjsPlayer.paused()) {
        console.info('was playing');
        this.playerState.playing = true;
      } else {
        this.playerState.playing = false;
      }
      this.vjsPlayer.pause();
    }

    const playlistHolder = document.getElementById('playlist-list-holder');
    if(playlistHolder.classList.contains('show')) {
      return;
    } else {
      this.playerState.playlistOpen = true;
      playlistHolder.classList.remove('hide');
      playlistHolder.classList.add('show');
      this.openPlaylistToggle();
    }
  }

  openPlaylistToggle() {
    return;
    const toggleHolder = document.getElementById('playlist-toggle');
    if(toggleHolder.classList.contains('open')) {
      return;
    } else {
      toggleHolder.classList.remove('close');
      toggleHolder.classList.add('open');
    }
  }

  /**
  handlePlaylistItemClick(e) {
    console.info("handlePlaylistItemClick", e);
    this.closePlaylist();
  }
  */

  toSizedImage(img, size, ending) {
    img = img.split("?").shift().split(".net/");
    const dom = img.shift() + ".net/";
    img = img.join().split(".");

    const maxWidth = getViewportWidth();

    const w = size.split('x').shift();

    //console.info('size', maxWidth, w);


    if(w > maxWidth || w === 'full') {
      size = size.replace(w, maxWidth);
    }

    const oEnding = img.pop();
    if(this.webp) { 
      //console.info('have webp');
      ending = 'webp';
    }
    return '//' + dom.replace(/^https?\:\/\//i, "") + 'sized/' + oEnding + '/' + size + '/' + img + '.' + ending;
  }

  turnOnPlaylistContainer() {
    //console.info('turnOnPlaylistContainer');
    //const playlistToggle = document.getElementById('playlist-toggle');
    //playlistToggle.onclick = this.openPlaylist.bind(this);

    const playlistItems = document.getElementsByClassName('vjs-playlist-item');


    for (let i = 0; i < playlistItems.length; i++) {
      //playlistItems[i].addEventListener('click', this.handlePlaylistItemClick.bind(this), false);
    }

    const closeButton = document.createElement('div');
    closeButton.setAttribute('id', 'close-playlist-button');
    closeButton.innerText = 'Close Playlist';
    closeButton.onclick = this.closePlaylist.bind(this);

    //document.getElementById('playlist-holder').insertBefore(header, document.getElementById('playlist-list-holder'));
    //document.getElementById('playlist-list-holder').insertBefore(closeButton, document.getElementById('playlist-list-holder').firstChild);
  }

};

const raiseError = (e) => {
  console.error(e);
  const dimData = {
        hitType: 'event',
        eventCategory: pageParams.distribution_id || e,
        eventAction: 'error',
        eventLabel: e,
        dimension1: null,
        dimension2: pageParams.ms_uuid,
        dimension3: null,
        dimension4: pageParams.mi_uuid,
        dimension5: null,
    };

    //console.info('handleTracking dims', dimData);

    ga('send', dimData);
};

//console.info("BB", videojs.browser);
ga('create', gaSiteId, 'auto');
ga('send', 'pageview', {
  dimension8 : pageParams.autoplay
});

if(pageParams.distribution_id) {

  window.lazySizesConfig = window.lazySizesConfig || {};

  // use .lazy instead of .lazyload
  window.lazySizesConfig.lazyClass = 'b-lazy';
  window.lazySizesConfig.loadMode = 1;

  lazySizes.init();

  const player = new bPOPPlayer(pageParams);

} else {

  raiseError('MISSING PAGE PARAMETER \'distribution_id\'');
}